var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	30473: {
		fallback: () => (__webpack_require__.e(1262).then(() => (() => (__webpack_require__(71262))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	92681: {
		fallback: () => (Promise.all([__webpack_require__.e(6465), __webpack_require__.e(8869)]).then(() => (() => (__webpack_require__(1250))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	88534: {
		fallback: () => (__webpack_require__.e(7774).then(() => (() => (__webpack_require__(27774))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	46701: {
		fallback: () => (__webpack_require__.e(1587).then(() => (() => (__webpack_require__(63968))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	45734: {
		fallback: () => (__webpack_require__.e(2565).then(() => (() => (__webpack_require__(94946))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	4561: {
		fallback: () => (Promise.all([__webpack_require__.e(7139), __webpack_require__.e(1532), __webpack_require__.e(9569), __webpack_require__.e(473), __webpack_require__.e(8534)]).then(() => (() => (__webpack_require__(19569))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/utils",

	},
	43749: {
		fallback: () => (Promise.all([__webpack_require__.e(7139), __webpack_require__.e(5507)]).then(() => (() => (__webpack_require__(25507))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/validator-ajv8",

	},
	56080: {
		fallback: () => (Promise.all([__webpack_require__.e(7139), __webpack_require__.e(1532), __webpack_require__.e(5060), __webpack_require__.e(3749)]).then(() => (() => (__webpack_require__(65060))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/core",

	},
	3854: {
		fallback: () => (__webpack_require__.e(2656).then(() => (() => (__webpack_require__(2656))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-dev-runtime",

	},
	10771: {
		fallback: () => (Promise.all([__webpack_require__.e(1), __webpack_require__.e(346), __webpack_require__.e(5663), __webpack_require__.e(8649), __webpack_require__.e(6080)]).then(() => (() => (__webpack_require__(53426))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/mui",

	},
	74721: {
		fallback: () => (Promise.all([__webpack_require__.e(6465), __webpack_require__.e(1), __webpack_require__.e(346), __webpack_require__.e(5663), __webpack_require__.e(708), __webpack_require__.e(1663), __webpack_require__.e(9689)]).then(() => (() => (__webpack_require__(79689))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=5.0.0 <10.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"473": [
		30473
	],
	"771": [
		10771
	],
	"2426": [
		74721,
		30473
	],
	"2681": [
		92681
	],
	"3749": [
		43749
	],
	"3854": [
		3854
	],
	"4561": [
		4561
	],
	"6080": [
		56080
	],
	"7258": [
		46701,
		45734
	],
	"8534": [
		88534
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}